import { useHasPermission } from "#src/contexts/AuthenticatedContext.helpers";
import { ButtonWithPopover } from "@validereinc/common-components";
import React, { PropsWithChildren } from "react";
import type { PermissionAwareExportButtonProps } from "./types";

/**
 * Export buttons in the app require `"reports:read"` and `"reports:write"` permissions.
 * This button doesn't get rendered if these permissions are missing.
 */
const PermissionAwareExportButton = (
  props: PropsWithChildren<PermissionAwareExportButtonProps>
) => {
  const {
    onClick,
    isExporting,
    label,
    variant,
    hasIcon = true,
    isDisabled,
    children,
  } = props;

  const [hasPermission] = useHasPermission({
    $and: ["reports:read", "reports:write"],
  });

  if (!hasPermission) return null;

  return (
    <ButtonWithPopover
      buttonProps={{
        ...(hasIcon ? { icon: "arrow-square-out" } : {}),
        variant: variant ?? "outline",
        onClick: () => {
          onClick?.();
        },
        isLoading: isExporting,
        disabled: isDisabled,
      }}
      label={label ?? "Export"}
    >
      {children}
    </ButtonWithPopover>
  );
};

export default PermissionAwareExportButton;
